import { playPath } from "../route.ts";

/** An address that leads nowhere: said so plainly, with the way to Play. */
export function Missing({ go }: { go: (to: string) => void }) {
  return (
    <main className="account">
      <header className="page-head">
        <div>
          <h1 className="page-title">Nothing at that address</h1>
          <p className="page-summary">The way may have moved, or the link was copied short.</p>
        </div>
      </header>
      <p>
        <a
          href={playPath()}
          onClick={(e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            go(playPath());
          }}
        >
          Back to Play
        </a>
      </p>
    </main>
  );
}
